const serverError = 500;
const expiredSession = 3402;
const requestCancelled = 3403;
const responseError = 3404;
const invalidData = 3405;
const stripeError = 3406;
const typeError = 3407;
const mediaError = 3408;

const errorCodes = {
  serverError,
  expiredSession,
  requestCancelled,
  responseError,
  invalidData,
  stripeError,
  typeError,
  mediaError,
};
export default errorCodes;
